<template>
  <CFooter :fixed="false">
    <CContainer fluid>
      <CRow>
        <CCol md="6" sm="12" style="text-align : left">
          Copyright
          <span class="ml-1">&copy; {{new Date().getFullYear()}}. All rights reserved | </span> <small>Version : 1.1.1</small>
        </CCol>
        <CCol md="6" sm="12" style="text-align : right">
          <span class="mr-1">Developed by</span>
          <a href="https://leopardtechlabs.com/" target="_blank">Leopard Tech Labs</a> for 
          <a href="https://wti.org.in" target="_blank">Wildlife Trust of India</a>
        </CCol>
      </CRow>
    </CContainer>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
